<template>
  <BreadCrumb class="hidden sm:block" />
  <ServicePage :entry="entry" :seomatic="seomatic" />
</template>

<script>
import gql from 'graphql-tag';
import { stripLocale } from '@/utils/i18n';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import ServicePage, { ServicePageFragment } from '@/components/service/ServicePage';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';
import { useSchema } from '@/composables/useSchema';
import { generateSchema as generateImprintSchema } from '@/schema/LegalNotice.schema';
import { useAppStore } from '@/stores/app';

export const ServiceQuery = gql`
  query ServiceQuery($site: String!, $uri: String!) {
    entry(section: "service", site: [$site], uri: [$uri]) {
      typeHandle
      ...EntryPageFragment
      ...ServicePageFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${ServicePageFragment}
  ${SeomaticFragment}
`;

export default defineNuxtComponent({
  name: 'ServicePageController',

  components: { ServicePage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    const { entry, seomatic } = await $craftRequest(ServiceQuery, variables);

    return { entry, seomatic };
  },

  created() {
    useEntryPage(this.entry, this.seomatic);
  },

  mounted() {
    // Generate imprint schema for imprint pages
    if (this.entry && this.entry?.schemaOrg?.enableSchemaOrg) {
      const { registerComponentSchema } = useSchema();
      const appStore = useAppStore();
      const siteIdentity = appStore.siteIdentity || {};

      // Inject legal notice schema if it is enabled in the CMS
      if (this.entry?.schemaOrg?.injectLegalNoticeSchema) {
        const schema = generateImprintSchema(siteIdentity);
        registerComponentSchema(schema, 'legal-notice-injection');
      }
    }
  },
});
</script>
